import { render, staticRenderFns } from "./DetailPenarikan.vue?vue&type=template&id=2c56f3ba&"
import script from "./DetailPenarikan.vue?vue&type=script&lang=js&"
export * from "./DetailPenarikan.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports